import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class PrimaryItemApi extends BaseApi {
  async getPrimaryItemList(
    params: APIPaths["/admin-dash/primary-item/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/admin-dash/primary-item/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/admin-dash/primary-item/list", { params })).data;
  }

  async postPrimaryItemNew(
    requestBody: APIPaths["/admin-dash/primary-item/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/admin-dash/primary-item/new"]["post"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.post("/admin-dash/primary-item/new", requestBody)).data;
  }

  async getPrimaryItemById(
    id: string,
  ): Promise<APIPaths["/admin-dash/primary-item/{id}"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get(`/admin-dash/primary-item/${id}`)).data;
  }

  async patchPrimaryItemById(
    id: string,
    requestBody: APIPaths["/admin-dash/primary-item/{id}"]["patch"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/admin-dash/primary-item/{id}"]["patch"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.patch(`/admin-dash/primary-item/${id}`, requestBody)).data;
  }

  async deletePrimaryItemById(
    id: string,
  ): Promise<APIPaths["/admin-dash/primary-item/{id}"]["delete"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.delete(`/admin-dash/primary-item/${id}`)).data;
  }

  async postPrimaryItemDuplicate(
    parameters: APIPaths["/admin-dash/primary-item/{id}/duplicate"]["post"]["parameters"]["path"],
    requestBody: APIPaths["/admin-dash/primary-item/{id}/duplicate"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/admin-dash/primary-item/{id}/duplicate"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post(`/admin-dash/primary-item/${parameters.id}/duplicate`, requestBody)).data;
  }

  async putPrimaryItemPosition(
    id: string,
    requestBody: APIPaths["/admin-dash/primary-item/{id}/position"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/admin-dash/primary-item/{id}/position"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/admin-dash/primary-item/${id}/position`, requestBody)).data;
  }
}
